
const formatDateTime = (datetime) => {
	const date = new Date(datetime);
	const dateString = date.toLocaleDateString('en-us');
	const timeString = date.toLocaleTimeString('en-us', { hour: '2-digit', minute: '2-digit' });

	return `${dateString} ${timeString.replace("AM", "a.m.").replace("PM", "p.m.")} CST`
}

export default formatDateTime;